var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.currentPageIsLogin())?_c('Navigation'):_vm._e(),_c('router-view'),_c('notifications',{attrs:{"group":"auth","position":"top center"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }